<div>
  <div class="floatinghead floatinghead-xs clearfix">
    <h5 class="mainhead mainhead-notifications" style="margin-bottom:30px !important"><span class="text">Notification Settings</span></h5>
    <button class="right-btn btn  btn-circle btn-green adduserbtn" href="#" (click)="onEditClick()" *ngIf="!IsEditClick" placement="top" tooltip="Edit Profile" ng-reflect-tooltip="Edit" ng-reflect-placement="top"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></button>
  </div>
  <div class="margin-bottom-20">
    <div class="row margin-bottom-0">
      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
        <h4 class="emailnotification-heading" style="margin-bottom:10px !important"><span class="text">Email Notifications</span></h4>
      </div>
    </div>
    <div class="row card my-3 scroll-container-all-notification">
      <div class="div-gray all-notfication-parentDiv">
        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-12">
          <div class="form-group all-notification-div">
            <label class="form-label form-label-heading">All Email Notifications</label>
            <!--<label class="form-label gray-text">Turn Off All Email Notifications</label>-->
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
          <section class="example-section">
            <mat-slide-toggle class="example-margin green-toggle"
             [(ngModel)]="checked"  [disabled]="!IsEditClick"
                              (change)="onToggle($event)">
            </mat-slide-toggle>
          </section>
        </div>
      </div>
    </div>

    <div class="card my-3 row margin-top-15">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Email Types</h5>
      </div>

      <div id="collapseNotifications" class="collapse show">
        <div class="card-body scroll-container">
          <div class="item-card" *ngFor="let notification of notificationListModel">
            <div class="item-content">
              <div class="form-group all-notification-div col-lg-10 col-md-10 col-sm-10 col-xs-12">
                <label class="form-label form-label-heading d-block">{{notification.EmailName}}</label>
                <p class="gray-text d-block">{{notification.Description}}</p>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 form-group custom-select-wrapper">
                <select class="form-control notification-select mt-2"
                        [ngModelOptions]="{ standalone: true }"
                        [disabled]="!IsEditClick" [(ngModel)]="notification.PriorityId">
                  <option [ngValue]="priority.id" *ngFor="let priority of priorityType">{{priority.description}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row margin-top-10" *ngIf="IsEditClick">
      <div class="text-right">
        <button type="button" class="btn btn-default btn-lg" (click)="onCancelClick()">Cancel</button>
        <button class="btn btn-success  btn-lg" (click)="onSaveNotificationClick()">Save</button>
      </div>
    </div>
  </div>
</div>
